// Do not edit this file, it is auto-generated at build time!
// See scripts/generate-oidc-settings.js to modify the generation of this file.
export const defaultOidcSettings = {
  client_id: 'urn:criipto:signupTalkmoreCriipto:no1', // default value for all orderflows
  response_type: 'code', // default value for all orderflows
  scope: 'openid email phone address birthdate', // default value for all orderflows
  ui_locales: 'nb', // default value for all orderflows
  redirect_uri: 'https://dev.talkmore.no/privat/abonnement/redirect', // vuex-oidc needs this property for initialization
  authority: 'https://talkmore.criipto.id', // vuex-oidc needs this property for initialization
};

export const defaultPartnerOidcSettings = {
  client_id: 'pnTalkmore', // default value for all orderflows
  response_type: 'code', // default value for all orderflows
  scope: 'openid http://id.trumf.no/scopes/medlem', // default value for all orderflows
  popupWindowTarget: '_self', // Defines the 'name'-tag value for the iframe - is this needed?
  ui_locales: 'nb', // default value for all orderflows
  grant_type: 'authorization_code',
  redirect_uri: 'https://dev.talkmore.no/privat/abonnement/redirect', // vuex-oidc needs this property for initialization
  authority: 'https://id.trumf.no', // vuex-oidc needs this property for initialization
};
